import { Wrapper, PricingWrapper, PriceHeading } from '@/components/BookingFinalise.styles'
import { Afterpay, Button, Heading } from '@big-red-group/storefront-common-ui'
import { formatCurrency } from '@big-red-group/storefront-common-checkout'

const BookingFinalise: React.FC<{
  handleBook: (event: any, buttonText?: string) => void
  subtotal: number
  loadingBooking: boolean
  disabled: boolean
  isVoucherRedemption?: boolean
  displayAfterpay?: boolean
}> = ({ handleBook, subtotal, loadingBooking, disabled, isVoucherRedemption = false, displayAfterpay = false }) => {
  const buttonText = isVoucherRedemption ? 'Finalise Booking' : 'Add to Cart'
  return (
    <Wrapper disabled={disabled}>
      <PricingWrapper>
        <PriceHeading>Total price</PriceHeading>
        <Heading as="div" size="M" spacing={false} dataTestId="gift-voucher-total">
          {formatCurrency(subtotal)}
        </Heading>
        {displayAfterpay && <Afterpay amount={subtotal} installment='4' />}
      </PricingWrapper>
      <Button
        onClick={(event) => handleBook(event, buttonText)}
        loading={loadingBooking}
        disabled={disabled}
        dataTestId="add-to-cart"
        size="S"
      >
        {buttonText}
      </Button>
    </Wrapper>
  )
}
export default BookingFinalise
